import { useEffect } from 'react'
import { RouteProps, useLocation, useNavigate } from 'react-router-dom'

type PrivateRouteProps = {
  children: JSX.Element
  valid: boolean
}

const PrivateRoute = (props: RouteProps & PrivateRouteProps) => {
  const { children, valid } = props
  const navigate = useNavigate()
  const location = useLocation()

  // React warns to use navigate in a useEffect, not right when component mounts.
  useEffect(() => {
    if (valid) return
    navigate(window.travURI, { state: { from: location } })
  }, [valid, navigate]) // eslint-disable-line react-hooks/exhaustive-deps

  if (valid) return children
  return null
}

export { PrivateRoute }
